import React, { useState, useEffect, useMemo } from 'react';
import { ReportCicloOrcamentario, getReportCurvaEconomica } from '@app/api/relatorios';
import GraficoCurva from '../../GraficoCurva/index'
import { Widget, GridView, SimpleView, Table, ColumnProps } from '@digital/ui';
import { Collapse, Icon } from 'antd';
const { Panel } = Collapse;

const CurvaEconomica = () => {
    const [relatorio, setRelatorio] = useState<ReportCicloOrcamentario>();

    useEffect(() => {
        getReportCurvaEconomica().then((data) => {
            setRelatorio(data);
        });
    }, []);

    return (
        <>
            {relatorio ? (

                <>
                    <SimpleView>
                        <GridView noform>
                            <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                                <Panel key="1" header="Gráfico" style={{ border: 0 }}>
                                    <Widget span={12} actions={[]}>
                                        <GraficoCurva relatorio={relatorio} carregarTabela={true} />
                                    </Widget>
                                </Panel>
                            </Collapse>

                        </GridView>
                    </SimpleView>
                </>
            ) : (<> </>)}
        </>
    );
};

export default CurvaEconomica;
